export default "__VITE_ASSET__DlaNqtp$__"